import {
  IconButton,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  Tooltip,
  Typography,
} from '@material-ui/core'
import { Delete } from '@material-ui/icons'
import React from 'react'

import PanelHeader from './PanelHeader'

export const PaymentOptionsPanel = ({ onDeletePaymentOption, paymentOptions }) => (
  <>
    <PanelHeader title="Payment Options" />
    {paymentOptions && paymentOptions.length > 0 ? (
      <List>
        {paymentOptions.map(paymentOption => (
          <span key={paymentOption.ccProfileId}>
            <ListItem>
              <ListItemText>&bull;&bull;&bull;&bull;&nbsp;{paymentOption.lastFour}</ListItemText>
              <ListItemText>{paymentOption.cardAddress?.zipcode}</ListItemText>
              <ListItemSecondaryAction>
                <Tooltip title="Delete">
                  <IconButton onClick={() => onDeletePaymentOption(paymentOption.ccProfileId)}>
                    <Delete />
                  </IconButton>
                </Tooltip>
              </ListItemSecondaryAction>
            </ListItem>
          </span>
        ))}
      </List>
    ) : (
      <Typography>You currently do not have any saved credit cards.</Typography>
    )}
  </>
)

export default PaymentOptionsPanel
